module.exports = __webpack_public_path__ + "static/media/roma-2.f08b1073.jpg";